import React from 'react';
import PropTypes from 'prop-types';
import './Well.css';

export default class Well extends React.Component {

    render() {
        return (
            <div className="well" style={this.props.style}>
                {this.props.children}
            </div>
        );
    }

}

Well.propTypes = {
    style: PropTypes.object,
};

Well.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/Well.jsx